import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CoreAuthenticatedModel, CoreLoginRequest } from './core-auth.models';
import { CoreAuthCookiesService } from './core-auth.cookies.service';
import { CORE_AUTH_CONFIG } from './core-auth.tokens';
import { CoreAuthConfig } from './core-auth.models';

@Injectable({
  providedIn: 'root',
})
export class CoreAuthService {
  constructor(
    private readonly http: HttpClient,
    private readonly msalService: MsalService,
    private readonly cookiesService: CoreAuthCookiesService,
    @Inject(CORE_AUTH_CONFIG) private readonly config: CoreAuthConfig,
  ) {}

  auth(request: CoreLoginRequest): Observable<unknown> {
    if (!this.config.endpoints?.authUrl) {
      return of(null);
    }

    return this.http.post(this.config.endpoints.authUrl, request);
  }

  login(request: CoreLoginRequest): Observable<CoreAuthenticatedModel> {
    if (!this.config.endpoints?.loginUrl) {
      throw new Error('CoreAuthConfig.endpoints.loginUrl is required for login requests.');
    }

    return this.http.post<CoreAuthenticatedModel>(this.config.endpoints.loginUrl, request).pipe(
      tap((response) => {
        this.cookiesService.setSessionCookies(response);
      }),
    );
  }

  loginWithRedirect(): void {
    this.msalService.loginRedirect({
      scopes: this.config.msal.scopes ?? [],
    });
  }

  logout(): void {
    this.cookiesService.clearSessionCookies();

    if (this.config.msal.interactionType !== undefined && this.config.msal.interactionType !== null) {
      if (this.config.msal.interactionType === InteractionType.Redirect) {
        this.msalService.logoutRedirect({
          postLogoutRedirectUri: this.config.msal.redirectUri,
        });
        return;
      }

      this.msalService.logoutPopup({
        postLogoutRedirectUri: this.config.msal.redirectUri,
        mainWindowRedirectUri: this.config.msal.redirectUri,
      });
      return;
    }

    this.msalService.logoutRedirect({
      postLogoutRedirectUri: this.config.msal.redirectUri,
    });
  }
}
